export default __webpack_public_path__ + "static/media/creativity.048dcb54.svg";